import * as Scrivito from "scrivito";
import { formatDateRange } from "../../utils/formatDateRange";
import { getCategoryLabel } from "./_trainingUtils";

const TrainingCourseCard = Scrivito.connect(({ course }) => {
  const image = course.get("image");
  const startDate = course.get("startDate");
  const endDate = course.get("endDate");
  const categories = course.get("category") || [];
  const language = course.language() || "de";

  return (
    <Scrivito.LinkTag
      to={course}
      className="text-decoration-none text-reset d-block h-100"
    >
      <div className="bg-white rounded overflow-hidden h-100">
        {image && (
          <Scrivito.ImageTag
            content={image}
            attribute="blob"
            className="w-100"
            style={{ objectFit: "cover", aspectRatio: "16/9" }}
          />
        )}
        <div className="p-3">
          <div className="fw-bold mb-1">{course.get("title")}</div>
          {startDate && (
            <div className="text-muted small">
              {formatDateRange(startDate, endDate, { locale: language })}
            </div>
          )}
          <div className="mt-2">
            {categories.map((k) => (
              <span key={k} className="badge rounded-pill bg-blue me-1">
                {getCategoryLabel(k, language)}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Scrivito.LinkTag>
  );
});

export default TrainingCourseCard;
